import { render } from "./TimeFormatToggle.vue?vue&type=template&id=e1a1a796"
import script from "./TimeFormatToggle.vue?vue&type=script&lang=js"
export * from "./TimeFormatToggle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__